import { gql } from '@apollo/client';
import { WAREHOUSE_FIELDS, WarehouseType } from 'graphql/types/WarehouseType';

export const SAVE_WAREHOUSE_FOR_WMS_SITE_MANAGEMENT = gql`
    mutation SaveWarehouseForWmsSiteManagement($warehouse: WarehouseTypeInput!) {
        result: saveWarehouseForWmsSiteManagement(warehouse: $warehouse) {
            ...WarehouseFields
        }
    }
    ${WAREHOUSE_FIELDS}
`;

export interface SaveWarehouseForWmsSiteManagementResponse {
    result: WarehouseType;
}
